<template>
  <div class="content-wrapper">
    <!-- Main content -->
    <section class="content">
      <section style="margin-bottom: 1%" v-if="$store.getters.hasFunction('payable_create')">
        <a-button type="primary" @click="createHandle">
          <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
          {{ $t('新增应付单') }}
        </a-button>
      </section>
      <div class="form-content">
        <a-row :gutter="16" style="margin-top: 15px">
          <a-col :span="6">
            <CommonSelect
              :isBu="true"
              :list="$store.state.settlementBuList"
              :placeholder="$t('结算组织')"
              :code.sync="formData.businessUnitCode"
              @change="searchHandle(1)"
            />
          </a-col>
          <a-col :span="6">
            <a-input
              allow-clear
              v-model.trim="formData.orderSn"
              :placeholder="$t('请输入应付单号')"
            />
          </a-col>
          <a-col :span="6">
            <DateRangePicker
              :needhms="false"
              @get_date="chooseAccountingDate"
              :placeholder="$t(`记账日期`)"
              :start-time="formData.accountingDateStart"
              :end-time="formData.accountingDateEnd"
            />
          </a-col>
          <a-col :span="6">
            <DateRangePicker
              :needhms="false"
              @get_date="chooseBizTime"
              :placeholder="$t(`业务日期`)"
              :start-time="formData.bizTimeStart"
              :end-time="formData.bizTimeEnd"
            />
          </a-col>
          <a-col :span="6">
            <CommonQuerySelect
              api="queryPurchaseSupplierList"
              :params="{
                status: 1,
              }"
              :placeholder="$t(`供应商`)"
              :code.sync="formData.payeeCode"
              :name.sync="formData.payeeName"
              valueName="supplier_code"
              labelName="supplier_name"
            />
          </a-col>
          <a-col :span="6">
            <CommonSelect
              :placeholder="$t('单据类型')"
              :list="payableOrderTypeList"
              :code.sync="formData.orderType"
            />
          </a-col>
          <a-col :span="6">
            <CommonSelect
              :list="payable_order_invoice_status"
              :code.sync="formData.invoiceStatus"
              :placeholder="$t('开票状态')"
            />
          </a-col>
          <a-col :span="6">
            <CommonSelect
              :list="payable_order_biz_status"
              :code.sync="formData.bizOrderStatus"
              :placeholder="$t('业务状态')"
            />
          </a-col>
          <a-col :span="6">
            <CommonSelect
              :placeholder="$t('源单类型')"
              :list="sourceOrderTypeList"
              :code.sync="formData.sourceOrderType"
            />
          </a-col>
          <a-col :span="6">
            <a-input
              allow-clear
              v-model.trim="formData.sourceOrderCode"
              :placeholder="$t('请输入源单号')"
            />
          </a-col>
          <a-col :span="6">
            <a-select
              v-model="formData.needGenerateVoucher"
              allow-clear
              :placeholder="$t('能否生成凭证')"
              style="width: 100%"
            >
              <a-select-option :value="1">{{ $t('需要') }}</a-select-option>
              <a-select-option :value="0">{{ $t('不需要') }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6">
            <a-select
              v-model="formData.voucherGenerated"
              allow-clear
              :placeholder="$t('已生成凭证')"
              style="width: 100%"
            >
              <a-select-option :value="1">{{ $t('是') }}</a-select-option>
              <a-select-option :value="0">{{ $t('否') }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row :gutter="16" class="mt10">
          <a-col :span="6">
            <a-button @click="searchHandle(1)" type="primary">
              <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
              {{ $t(`查询`) }}
            </a-button>
            <a-button @click="reset">
              <a-icon type="redo" />
              {{ $t(`重置`) }}
            </a-button>
          </a-col>
        </a-row>
      </div>

      <CommonTable
        class="mt10"
        ref="CommonTableRef"
        :statusList="payable_order_status"
        :showSelect="true"
        :selectedRowKeys.sync="selectedRowKeys"
        :selectedRows.sync="selectedRows"
        :scroll="{ x: 'max-content' }"
        :loading="tableLoading"
        :columns.sync="tableColumns"
        :data-source="tableData"
        :total="total"
        rowKey="id"
        @select="onSelectChange"
        @search="queryOrderList"
      >
        <template v-slot:header>
          <div class="flex-ct">
            <OperateBtn
              api="operateDoc"
              :text="$t('审核')"
              :params="{
                action: 'check',
                docType: docType,
                idList: selectedRowKeys,
              }"
              :disabled="selectedRows.length === 0"
              @success="handleCheckSuccess"
            />
            <a-button
              class="ml10"
              type="primary"
              @click="createInvoiceHandle"
              :disabled="selectedRows.length === 0"
            >
              <a-popover placement="topLeft">
                <template slot="content">
                  <div>
                    {{ $t('将应付单的商品信息带到发票创建页面') }}
                  </div>
                </template>
                <span>{{ $t('创建发票') }}</span>
                <a-icon type="question-circle" class="ml6" />
              </a-popover>
            </a-button>
            <!-- 同一个供应商、待核销/部分核销状态 planList里面status: "NORMAL"可以下推生成付款申请单、付款单 -->
            <PushBtn
              class="ml10"
              :docType="docType"
              :selectedRows="selectedRows"
              :disabled="selectedRows.length === 0"
              pageType="list"
            />
            <VoucherBtn
              class="ml10"
              :docType="docType"
              :selectedRows="selectedRows"
              :disabled="selectedRows.length === 0"
              @close="searchHandle"
            />
            <a-button
              class="ml10"
              type="danger"
              :disabled="selectedRowKeys.length === 0"
              :loading="batchCancelLoading"
              @click="confirmBatchCancel"
            >
              {{ $t('作废') }}
            </a-button>
          </div>
        </template>
        <!-- 应付单号 -->
        <template v-slot:orderSn="{ text, record }">
          <span>
            <a @click="viewDetail(record)">{{ text }}</a>
            <a-icon
              type="copy"
              class="ml6"
              style="cursor: pointer; color: #1890ff"
              @click.stop="copyOrderSn(text)"
            />
          </span>
        </template>
        <template v-slot:sourceOrderCode="{ record }">
          <a>{{ record.sourceOrderCode }}</a>
        </template>
        <!-- 业务单号 -->
        <template v-slot:otherSns="{ record }">
          <div>
            {{ $t('业务单号') }}:
            <span>{{ record.bizOrderSn }}</span>
          </div>
          <div v-if="record.referenceNo">
            {{ $t('跟踪单号') }}:
            <span>{{ record.referenceNo }}</span>
          </div>
          <div v-if="record.asnOrderSn">
            {{
              record.sourceOrderType === 'PurchaseReturnOrder'
                ? $t('采购退货单')
                : $t('预到货通知单号')
            }}:
            <span class="text-link">{{ record.asnOrderSn }}</span>
          </div>
          <div v-if="record.receivedOrderSn">
            {{
              record.sourceOrderType === 'PurchaseReturnOrder' ? $t('出库单号') : $t('入库单号')
            }}:
            <span class="text-link">{{ record.receivedOrderSn }}</span>
          </div>
        </template>
        <!-- 金额（未含税） -->
        <template v-slot:amountWithoutTax="{ text }">¥ {{ text | toThousands }}</template>
        <!-- 税额 -->
        <template v-slot:taxAmount="{ text }">¥ {{ text | toThousands }}</template>
        <!-- 价税合计 -->
        <template v-slot:payableAmount="{ text }">¥ {{ text | toThousands }}</template>
        <!-- 未核销金额 -->
        <template v-slot:writtenOffAmount="{ text, record }">
          ¥ {{ subtract(record.payableAmount, text) | toThousands }}
        </template>
        <!-- 开票金额 -->
        <template v-slot:invoicedAmount="{ text }">
          <span v-if="text">¥ {{ text | toThousands }}</span>
        </template>
      </CommonTable>
    </section>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import DateRangePicker from '@component/dateRangePicker'
import CommonSelect from '@component/commonSelect'
import CommonTable from '@component/commonTable'
import PushBtn from '@component/pushBtn'
import VoucherBtn from '@component/voucherBtn'
import { convertKeysToCamelCase, spaceToComma, copy, fetchDocumentMappings } from '@/common'
import { subtract } from '@/common/number'
export default {
  name: 'payableList',
  activated() {
    this.searchHandle()
    this.fetchMappings()
  },
  components: {
    DateRangePicker,
    CommonSelect,
    CommonTable,
    PushBtn,
    VoucherBtn,
  },
  data() {
    return {
      docType: 'PayableOrder',
      formData: {
        orderSn: undefined,
        referenceNo: undefined,
        bizTimeStart: undefined,
        bizTimeEnd: undefined,
        accountingDateStart: undefined,
        accountingDateEnd: undefined,
        invoiceStatus: undefined,
        bizOrderStatus: undefined,
        payeeCode: undefined,
        status: '',
        sourceOrderCode: undefined,
        sourceOrderType: undefined,
        needGenerateVoucher: undefined,
        voucherGenerated: undefined,
      },
      tableLoading: false,
      batchCancelLoading: false,
      total: 0,
      selectedRowKeys: [],
      selectedRows: [],
      tableData: [],
      visible: false,
      nextVisible: false,
      pendingSelectedIds: [], // 保存待重新选中的订单ID
      mappings: {
        orderType: {},
        sourceOrderType: {},
      },
    }
  },
  computed: {
    ...mapState([
      'payable_order_status',
      'payable_order_invoice_status',
      'payable_order_biz_status',
    ]),
    ...mapGetters([
      'payableOrderStatusMapping',
      'payableOrderTypeMapping',
      'invoiceTypeMapping',
      'payableOrderInvoiceStatusMapping',
      'sourceOrderTypeMapping',
      'bizOrderStatusMapping',
    ]),
    scrollHeight() {
      return window.innerHeight - 470
    },
    payableOrderTypeList() {
      if (!this.mappings || !this.mappings.orderType) return []
      return Object.keys(this.mappings.orderType).map((key) => ({
        code: key,
        name: this.mappings.orderType[key],
      }))
    },
    sourceOrderTypeList() {
      if (!this.mappings || !this.mappings.sourceOrderType) return []
      return Object.keys(this.mappings.sourceOrderType).map((key) => ({
        code: key,
        name: this.mappings.sourceOrderType[key],
      }))
    },
    tableColumns() {
      return [
        {
          dataIndex: 'orderSn',
          title: this.$t('应付单号'),
          key: 'orderSn',
          width: 200,
          scopedSlots: { customRender: 'orderSn' },
        },
        {
          title: this.$t('单据状态'),
          width: 100,
          dataIndex: 'status',
          customRender: (text) => this.payableOrderStatusMapping[text],
        },
        {
          title: this.$t('单据类型'),
          width: 100,
          dataIndex: 'orderType',
          customRender: (text) => this.mappings.orderType[text] || text,
        },
        {
          title: this.$t('往来单位类型'),
          width: 120,
          dataIndex: 'payeeType',
          customRender: (text) => this.$store.getters.contactTypeMapping[text],
        },
        {
          title: this.$t('往来单位名称'),
          width: 120,
          dataIndex: 'payeeName',
        },
        {
          title: this.$t('结算组织'),
          width: 120,
          dataIndex: 'businessUnitName',
        },
        {
          title: this.$t('记账日期'),
          width: 200,
          dataIndex: 'accountingDate',
        },
        {
          title: this.$t('金额') + '(' + this.$t('未含税') + ')',
          width: 120,
          dataIndex: 'amountWithoutTax',
          scopedSlots: { customRender: 'amountWithoutTax' },
        },
        {
          title: this.$t('税额'),
          width: 120,
          dataIndex: 'taxAmount',
          scopedSlots: { customRender: 'taxAmount' },
        },
        {
          title: this.$t('价税合计'),
          width: 120,
          dataIndex: 'payableAmount',
          scopedSlots: { customRender: 'payableAmount' },
        },
        {
          title: this.$t('未核销金额'),
          width: 120,
          dataIndex: 'writtenOffAmount',
          scopedSlots: { customRender: 'writtenOffAmount' },
        },
        {
          title: this.$t('源单类型'),
          dataIndex: 'sourceOrderType',
          width: 100,
          customRender: (text) => this.mappings.sourceOrderType[text] || text,
        },
        {
          title: this.$t('源单编码'),
          dataIndex: 'sourceOrderCode',
          width: 220,
          scopedSlots: { customRender: 'sourceOrderCode' },
        },
        {
          title: this.$t('能否生成凭证'),
          dataIndex: 'needGenerateVoucher',
          width: 100,
          customRender: (text, record) => {
            const val = record.needGenerateVoucher ?? record.need_generate_voucher
            return val === 1 ? this.$t('需要') : val === 0 ? this.$t('不需要') : ''
          },
        },
        {
          title: this.$t('是否生成凭证'),
          dataIndex: 'voucherGenerated',
          width: 100,
          customRender: (text) => (text ? this.$t('是') : this.$t('否')),
        },
        {
          title: this.$t('凭证号'),
          dataIndex: 'voucherNo',
          width: 100,
        },
        {
          title: this.$t('分期付款次数'),
          width: 100,
          dataIndex: 'installments',
        },
        {
          title: this.$t('预付款比例') + '(%)',
          width: 150,
          dataIndex: 'prepaymentRatio',
        },
        {
          title: this.$t('业务单号'),
          dataIndex: 'otherSns',
          width: 320,
          scopedSlots: { customRender: 'otherSns' },
        },
        {
          title: this.$t('业务状态'),
          dataIndex: 'bizOrderStatus',
          width: 100,
          customRender: (text) => this.bizOrderStatusMapping[text],
        },
        {
          title: this.$t('开票金额'),
          dataIndex: 'invoicedAmount',
          width: 120,
          scopedSlots: { customRender: 'invoicedAmount' },
        },
        {
          title: this.$t('开票状态'),
          dataIndex: 'invoiceStatus',
          width: 150,
          customRender: (text) => this.payableOrderInvoiceStatusMapping[text],
        },
        {
          title: this.$t('开票时间'),
          dataIndex: 'invoiceTime',
          width: 160,
        },
        {
          title: this.$t('备注'),
          width: 250,
          dataIndex: 'remark',
        },
        {
          title: this.$t('创建时间'),
          dataIndex: 'createdAt',
          width: 160,
        },
      ]
    },
  },
  methods: {
    ...mapMutations(['addPane']),
    async fetchMappings() {
      this.mappings = await fetchDocumentMappings(this.docType, ['orderType', 'sourceOrderType'])
    },
    subtract,
    reset() {
      const mappings = this.mappings
      Object.assign(this.$data, this.$options.data.call(this))
      this.mappings = mappings
      this.searchHandle(1)
    },
    createHandle() {
      this.$router.push({
        name: 'payableDetail',
      })
    },
    viewDetail(record) {
      this.addPane({
        view: 'payableManage/payableDetail/' + record.orderSn,
        name: 'detailSn',
        query: {
          id: record.id,
          sn: record.orderSn,
        },
        route: `/payableManage/payableDetail?id=${record.id}&sn=${record.orderSn}`,
      })
    },
    chooseBizTime(date) {
      this.formData.bizTimeStart = date.start_time
      this.formData.bizTimeEnd = date.end_time
    },
    chooseAccountingDate(date) {
      this.formData.accountingDateStart = date.start_time
      this.formData.accountingDateEnd = date.end_time
    },
    async queryOrderList(params) {
      if (!this.formData.businessUnitCode) return
      let data = {
        ...this.formData,
        ...params,
      }
      let orderSn = spaceToComma(this.formData.orderSn)
      if (orderSn.includes(',')) {
        data.orderSnList = orderSn.split(',')
        delete data.orderSn
      } else if (orderSn) {
        data.orderSn = orderSn
      }
      this.tableLoading = true
      let res = await http({
        type: 'post',
        url: api.getPayableList,
        data,
      })
      let purchaseOrderList = [...(res.result.list || '')]
      this.tableData = convertKeysToCamelCase(purchaseOrderList)
      this.total = res.result.total
      this.tableLoading = false
      // 如果有待恢复的选中项，在列表加载完成后恢复
      if (this.pendingSelectedIds.length > 0) {
        this.$nextTick(() => {
          this.restoreSelection()
        })
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    confirmBatchCancel() {
      const invalidRows = this.selectedRows.filter(
        (row) => !['DRAFT', 'WAIT_CHECK', 'WAIT_WRITTEN_OFF'].includes(row.status)
      )
      if (invalidRows.length > 0) {
        this.$message.warning(this.$t('只有草稿、待审核和待核销状态的单据可以作废'))
        return
      }
      this.$confirm({
        title: this.$t('确认操作'),
        content: `${this.$t('是否确认作废已选中的')} ${this.selectedRowKeys.length} ${this.$t(
          '个单据'
        )}？`,
        onOk: () => this.batchCancel(),
      })
    },
    async batchCancel() {
      this.batchCancelLoading = true
      try {
        const promises = this.selectedRowKeys.map((id) =>
          http({
            url: api.operateDoc,
            data: {
              action: 'cancel',
              docType: this.docType,
              idList: [id],
            },
          })
        )
        await Promise.all(promises)
        this.$success({
          title: this.$t('成功'),
          content: this.$t('作废成功'),
        })
        this.searchHandle()
      } catch (err) {
        this.searchHandle()
      } finally {
        this.batchCancelLoading = false
      }
    },
    createInvoiceHandle() {
      if (this.selectedRowKeys.length == 0) {
        this.$message.warning(this.$t('请选择需要创建的订单'))
        return
      }
      let list = []
      this.selectedRows.forEach((item) => {
        list.push(...item.itemList)
      })
      localStorage.setItem('payableOrderPushdata', JSON.stringify(list))
      this.$router.push({
        name: 'invoiceDetail',
        query: {
          bizType: 'PURCHASE',
        },
      })
    },
    searchHandle(pageNo) {
      this.selectedRowKeys = []
      this.selectedRows = []
      this.$refs.CommonTableRef.queryList(pageNo)
    },
    copyOrderSn(text) {
      copy(text)
    },
    handleCheckSuccess() {
      // 如果当前状态是待审核，保存选中的订单ID
      const currentStatus = this.$refs.CommonTableRef?.status
      if (currentStatus === 'WAIT_CHECK') {
        this.pendingSelectedIds = [...this.selectedRowKeys]
        // 切换tab到待核销状态
        this.$refs.CommonTableRef.setSearchStatus('WAIT_WRITTEN_OFF')
      } else {
        this.searchHandle()
      }
    },
    restoreSelection() {
      if (this.pendingSelectedIds.length === 0) return
      // 根据保存的ID重新选中
      const selectedKeys = []
      const selectedRows = []
      this.tableData.forEach((row) => {
        if (this.pendingSelectedIds.includes(row.id)) {
          selectedKeys.push(row.id)
          selectedRows.push(row)
        }
      })
      if (selectedKeys.length > 0) {
        // 通过 CommonTable 的 onSelectChange 方法来更新选中状态
        this.$refs.CommonTableRef.onSelectChange(selectedKeys, selectedRows)
      }
      this.pendingSelectedIds = []
    },
  },
}
</script>
